import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpService } from '../../services/http.service';
import { ConfigService } from '../../services/config.service';
import { TenantUtil } from '../../utils/tenant.util';
import {
  Auth0OrganizationResponse,
  OrganizationData
} from '../interfaces/auth0.interface';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private httpService = inject(HttpService);
  private configService = inject(ConfigService);

  getOrganizationData(): Observable<OrganizationData> {
    const tenant = TenantUtil.getCurrentTenant(this.configService.app.environment);

    return this.httpService.get<Auth0OrganizationResponse>('/auth0-organization', { tenant })
      .pipe(
        map(response => this.transformOrganizationResponse(response))
      );
  }

  private transformOrganizationResponse(response: Auth0OrganizationResponse): OrganizationData {
    return {
      organizationId: response.organization_id,
      clientId: response.auth0_client_id,
      organizationDomain: response.auth0_organization_domain,
      altOrganizationDomain: response.auth0_alternate_organization_domain,
      altClientId: response.auth0_alternate_client_id,
      altOrganizationId: response.auth0_alternate_organization_id,
    };
  }
}
